import React from 'react';

function QuestionListItem({ field, index, register, watch, setValue }) {
  // For group type (like Mice/Rats)
  if (field.type === "group") {
    return (
      <div className="d-flex question-field-container">
        <div className="mr-2 sequence-number">
          <p className="sequence-number-text">{index + 1}</p>
        </div>
        <div>
          <p className="question-title-red-text">{field.label}</p>
          <p className="question-text">{field.question}</p>
          <div className="">
            {field.fields.map((sub, subIdx) => (
              <div className="d-flex align-items-center mt-2" key={sub.name}>
                <div style={{ minWidth: 60 }}>
                  <p
                    className="group-question-text mr-2"
                    style={{ minWidth: 40 }}
                  >
                    {sub.label}
                  </p>
                </div>
                {sub.options.map((opt, optIdx) => (
                  <div
                    className="d-flex align-items-center mr-32"
                    key={opt.label}
                  >
                    <label className="custom-checkbox-large mr-2">
                      <input
                        type="radio"
                        value={opt.value == watch(sub.name)}
                        checked={opt.value == watch(sub.name) ? true : false}
                        onChange={() => setValue(sub.name, opt.value)}
                      />
                      <span className="checkmark-large-radio"></span>
                    </label>
                    <p className="question-text mr-2">{opt.label}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // For radio type (like Mold, Cockroaches)
  if (field.type === "textarea") {
    return (
      <div className="d-flex question-field-container border-none">
        <div className="mr-2 sequence-number border-primary">
          <p className="sequence-number-text color-primary">{index + 1}</p>
        </div>
        <div style={{ width: "100%" }}>
          <p className="question-title-red-text color-primary">{field.label}</p>
          <p className="question-text">{field.question}</p>
          <textarea
            className="form-control note-textarea"
            rows={3}
            name={field.name}
            {...register(field.name)}
          />
        </div>
      </div>
    );
  }

  // For radio type (like Mold, Cockroaches)
  return (
    <div className="d-flex question-field-container">
      <div className="mr-2 sequence-number">
        <p className="sequence-number-text">{index + 1}</p>
      </div>
      <div>
        <p className="question-title-red-text">{field.label}</p>
        <p className="question-text">{field.question}</p>
        <div className="d-flex mt-2">
          {field.options.map((opt, optIdx) => (
            <div className="d-flex align-items-center mr-32" key={opt.label}>
              <label className="custom-checkbox-large mr-2">
                <input
                  type="radio"
                  value={opt.value == watch(field.name)}
                  checked={opt.value == watch(field.name) ? true : false}
                  onChange={() => setValue(field.name, opt.value)}
                />
                <span className="checkmark-large-radio"></span>
              </label>
              <p className="question-text">{opt.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default QuestionListItem;